import React from 'react';
import { useDispatch } from 'react-redux';
import { updateScriptOptions } from './index';

export default function useUpdateScriptOptions() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(updateScriptOptions(payload)), [dispatch]);
}
